/* tslint:disable */
/* eslint-disable */
/**
 * Corrigo API
 * fejlesztői
 *
 * The version of the OpenAPI document: 1.5.2
 * Contact: kerezsigergely@infobex.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
/**
 *
 */
export class ConfigApi extends runtime.BaseAPI {
    /**
     *  [ID: GetUiConfig]
     * @deprecated
     */
    getUiConfigRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/config/ui`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     *  [ID: GetUiConfig]
     * @deprecated
     */
    getUiConfig(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getUiConfigRaw(initOverrides);
            return yield response.value();
        });
    }
}
